import { withStyles, Divider, Grid, Button } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

const styles = (theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    minWidth: 42,
    maxWidth: 45,
    justifyContent: "space-between",
  },
  header: {
    fontSize: 14,
    color: theme.HeaderSelectedText,
    padding: "8px 24px",
    fontWeight: 600,
    writingMode: "vertical-rl",
    display: "flex",
    alignItems: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 100,
    width: "100%",
  },
  divider: {
    backgroundColor: theme.AppBGColor,
  },
  sidePanelFooter: {
    background: theme.loadingBGColor,
    height: "10%",
    marginBottom:40,
  },
  collapsedButton: {
    minWidth: 42,
    maxWidth: 42,
    color: theme.iconColor,
    height: "100%",
  },
  collapseIcon: {
    transform: "rotate(90deg)",
  },
});

const CollapsedSidePane = ({ classes, toggleExpand }) => (
    <div id="sidePanel_collapsed" className={classes.container}>
      <div>
        <Grid item xs={12} className={classes.header}>
          Route Mapping Details
        </Grid>
      </div>
      <div id="sidePanelToggle" className={classes.sidePanelFooter}>
        <Divider className={classes.divider} />
        <Button
          classes={{ root: classes.collapsedButton }}
          onClick={toggleExpand}
        >
          <ExpandMore className={classes.collapseIcon} />
        </Button>
      </div>
    </div>
);

export default withStyles(styles)(CollapsedSidePane);
